export const hasPropertyValues = (object: object, requiredProperties?: string[]): boolean => {
  const isNotEmpty = !!Object.keys(object).length;

  const hasRequiredValues = requiredProperties
    ? requiredProperties.map(req => object[req]).filter(f => !!f).length === requiredProperties.length
    : true;

  const hasValues = !Object.keys(object).map(name => object[name]).filter(f => !f).length;

  return isNotEmpty && hasValues && hasRequiredValues;
};
